<template>
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-md-6">
         <modal-rec-facial />
      </div>
    </div>
  </div>
</template>
<script>
import { BaseInput } from "@/components";
import estadosjs from "./estados";
import ModalRecFacial from "../../../../pages/Pages/RegistrarPontoFuncionario/ModalRecFacial.vue";

export default {
  name: "foto",
  components: {
    BaseInput,
    ModalRecFacial
  },

  data() {
    return {
      model: {
        imgRecente: "",
      },
      modelValidations: {
        imgRecente: {
          required: false,
          min: 0
        },
      }
    };
  },

  mounted(){
  },

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },


    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },


  },


};
</script>
<style></style>
